"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = void 0;
/**
 * Play the song notation after next #START depending on if playing in
 * singleplayer or multiplayer.
 */
class Style {
    constructor(id, name) {
        this._id = id;
        this._name = name;
    }
    static fromId(id, strict = true) {
        const style = Style._values.find((s) => s._id === id);
        if (style) {
            return style;
        }
        if (strict) {
            throw new Error(`Invalid style id: ${id}`);
        }
    }
    static fromName(name, strict = true) {
        const style = Style._values.find((s) => s._name === name);
        if (style) {
            return style;
        }
        if (strict) {
            throw new Error(`Invalid style name: ${name}`);
        }
    }
    static fromRaw(raw, strict = true) {
        const parsedValue = parseInt(raw, 10);
        return isNaN(parsedValue)
            ? Style.fromName(raw, strict)
            : Style.fromId(parsedValue, strict);
    }
    toString() {
        return this._name;
    }
}
exports.Style = Style;
Style.Single = new Style(1, 'Single');
Style.Double = new Style(2, 'Double');
Style.Couple = new Style(2, 'Couple');
Style._values = [Style.Single, Style.Double, Style.Couple];
